"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _context14;

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  getHelpArticles: true,
  getArticleData: true
};
exports.getArticleData = exports.getHelpArticles = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _environment = require("../environment");

var _i18n = require("../i18n");

var _session = require("../session");

var _models = require("./models");

_forEachInstanceProperty2(_context14 = _Object$keys2(_models)).call(_context14, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _models[key];
    }
  });
});

var _html = require("./html");

var _query = require("./query");

var _constants = require("./constants");

var SetUrlType;

(function (SetUrlType) {
  SetUrlType["Search"] = "search";
  SetUrlType["Browse"] = "browse";
})(SetUrlType || (SetUrlType = {}));

var setParams = function setParams(data) {
  var _context;

  var oApp = data.oApp.join('+');
  var paramObj = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {
    oApp: oApp
  });
  var paramsArr = (0, _map.default)(_context = (0, _keys.default)(paramObj)).call(_context, function (key) {
    var _context2;

    return (0, _concat.default)(_context2 = "".concat(key, "=")).call(_context2, paramObj[key]);
  });
  return paramsArr.join('&');
};

var setSupportingUrl = function setSupportingUrl(data, product, index, type) {
  var _context3;

  var searchParamData = type === SetUrlType.Search ? {
    oApp: data.oApp,
    oLang: data.oLang,
    oCountry: data.oCountry,
    oUserType: data.oUserType,
    index: index,
    q: ''
  } : null;
  var url;
  var params = setParams(searchParamData !== null && searchParamData !== void 0 ? searchParamData : data);

  if (type === SetUrlType.Search) {
    url = product === _models.PrimaryProduct.Onvio ? (0, _constants.onvioSearchUri)(data.oCountry, data.oLang, data.oUserType) : (0, _constants.onbalanceSearchUri)(data.oCountry, data.oLang);
  } else {
    url = product === _models.PrimaryProduct.Onvio ? (0, _constants.onvioBrowseSubjectsUri)(data.oCountry, data.oLang, data.oUserType) : (0, _constants.onbalanceBrowseSubjectsUri)(data.oCountry, data.oLang);
  }

  return (0, _concat.default)(_context3 = "".concat(url, "?")).call(_context3, params);
};

var setTaxYear = function setTaxYear() {
  var d = new Date();
  var month = d.getMonth();
  var year = d.getFullYear();
  year = month === 11 ? year : year - 1;
  return year.toString().substr(-2);
};

var setOApp = function setOApp(product, apps) {
  var oAppVals = [];

  if (apps && apps.length > 0 && product === _models.PrimaryProduct.Onvio) {
    (0, _forEach.default)(apps).call(apps, function (app) {
      switch (app) {
        case _models.Applications.Tax:
          {
            oAppVals.push('tax');
            oAppVals.push("ot".concat(setTaxYear()));
            break;
          }

        case _models.Applications.Workpapers:
          {
            oAppVals.push('workpapers');
            break;
          }

        case _models.Applications.TrialBalance:
          {
            oAppVals.push('trialbalance');
            break;
          }

        case _models.Applications.CheckpointEngage:
          {
            oAppVals.push('checkpoint');
            break;
          }

        case _models.Applications.Accounting:
          {
            oAppVals.push('accounting');
            break;
          }

        case _models.Applications.TimeAndBilling:
          {
            oAppVals.push('time_and_billing');
            break;
          }

        case _models.Applications.CompanyFormation:
          {
            oAppVals.push('companyformation');
            break;
          }

        case _models.Applications.Accounts:
          {
            oAppVals.push('accounts');
            break;
          }

        case _models.Applications.Secretarial:
          {
            oAppVals.push('secretarial');
            break;
          }

        case _models.Applications.Advisory:
          {
            oAppVals.push('advisory');
            break;
          }

        case _models.Applications.VAT:
          {
            oAppVals.push('vat');
            break;
          }

        default:
          {
            if (!(0, _includes.default)(oAppVals).call(oAppVals, 'core')) {
              oAppVals.push('core');
            }

            break;
          }
      }
    });
  } else if (product === _models.PrimaryProduct.Onbalance) {
    if (apps && apps.length > 0) {
      (0, _forEach.default)(apps).call(apps, function (app) {
        switch (app) {
          case _models.Applications.Recibos:
            {
              oAppVals.push('recibos');
              break;
            }

          default:
            {
              if (!(0, _includes.default)(oAppVals).call(oAppVals, 'samba')) {
                oAppVals.push('samba');
              }

              break;
            }
        }
      });
    } else {
      oAppVals.push('samba');
    }
  } else {
    oAppVals = ['core', 'accounting', 'tax', "ot".concat(setTaxYear()), 'checkpoint', 'workpapers', 'time_and_billing', 'trialbalance', 'companyformation', 'accounts', 'secretarial', 'advisory', 'vat'];
  }

  return oAppVals;
};

var setTCData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data, product) {
    var _data$locale, _data$userType;

    var oUserID, oApp, locale, localeArr, oCountry, oLang, oUserType, tcData, _context4, _context5, _context6, _context7;

    return _regenerator.default.wrap(function _callee$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return (0, _session.getContactId)();

          case 2:
            oUserID = _context8.sent;
            oApp = setOApp(product, data.apps);
            locale = (_data$locale = data.locale) !== null && _data$locale !== void 0 ? _data$locale : (0, _i18n.getCurrentLanguage)();
            localeArr = locale.split('-');
            oCountry = localeArr[1].toLowerCase();
            oLang = localeArr[0];
            oUserType = (_data$userType = data.userType) !== null && _data$userType !== void 0 ? _data$userType : product === _models.PrimaryProduct.Onvio ? _models.UserType.Staff : _models.UserType.Admin;
            tcData = {
              oApp: oApp,
              oUserType: oUserType,
              oUserID: oUserID,
              oCountry: oCountry,
              oLang: oLang
            };

            if (product === _models.PrimaryProduct.Onvio) {
              tcData.client = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "onvio-".concat(oCountry, "-")).call(_context5, oLang, "-")).call(_context4, oUserType);
              tcData.proxystylesheet = (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "onvio-".concat(oCountry, "-")).call(_context7, oLang, "-")).call(_context6, oUserType);
            }

            return _context8.abrupt("return", tcData);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee);
  }));

  return function setTCData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getIndex = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(lang, product, index) {
    var newIndex;
    return _regenerator.default.wrap(function _callee2$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (index === null || index === void 0 ? void 0 : (0, _includes.default)(index).call(index, '{lang}')) {
              newIndex = index.replace('{lang}', lang);
            } else {
              newIndex = product === _models.PrimaryProduct.Onbalance ? _models.HelpIndexes.Onbalance.replace('{lang}', lang) : _models.HelpIndexes.Onvio.replace('{lang}', lang);
            }

            return _context9.abrupt("return", newIndex);

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee2);
  }));

  return function getIndex(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var setRawDataParam = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(data) {
    var product, tcData, index;
    return _regenerator.default.wrap(function _callee3$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return (0, _environment.getPrimaryProduct)();

          case 2:
            product = _context10.sent;
            _context10.next = 5;
            return setTCData(data, product);

          case 5:
            tcData = _context10.sent;
            _context10.next = 8;
            return getIndex(tcData.oLang, product, data.index);

          case 8:
            index = _context10.sent;
            return _context10.abrupt("return", {
              tcData: tcData,
              product: product,
              sortNames: data.sortNames,
              sortDirs: data.sortDirs,
              index: index,
              screens: data.screens
            });

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee3);
  }));

  return function setRawDataParam(_x6) {
    return _ref3.apply(this, arguments);
  };
}();

var getHelpArticles = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(data) {
    var _context11;

    var rawHelpDataParam, rawData, topics, howToUrl, searchUrl;
    return _regenerator.default.wrap(function _callee4$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return setRawDataParam(data);

          case 2:
            rawHelpDataParam = _context12.sent;
            _context12.next = 5;
            return (0, _query.getRawHelpData)(rawHelpDataParam);

          case 5:
            rawData = _context12.sent;
            topics = (0, _map.default)(_context11 = rawData.hits.hits).call(_context11, function (article) {
              return {
                title: article._source.title,
                url: article._source.url
              };
            });
            howToUrl = setSupportingUrl(rawHelpDataParam.tcData, rawHelpDataParam.product, rawHelpDataParam.index, SetUrlType.Browse);
            searchUrl = setSupportingUrl(rawHelpDataParam.tcData, rawHelpDataParam.product, rawHelpDataParam.index, SetUrlType.Search);
            return _context12.abrupt("return", {
              howToUrl: howToUrl,
              searchUrl: searchUrl,
              topics: topics
            });

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee4);
  }));

  return function getHelpArticles(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getHelpArticles = getHelpArticles;

var getArticleData = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(data) {
    var rawHelpDataParam, rawData;
    return _regenerator.default.wrap(function _callee5$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return setRawDataParam(data);

          case 2:
            rawHelpDataParam = _context13.sent;
            _context13.next = 5;
            return (0, _query.getRawHelpData)(rawHelpDataParam);

          case 5:
            rawData = _context13.sent;
            return _context13.abrupt("return", (0, _html.getTagData)(rawData, data.tags));

          case 7:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee5);
  }));

  return function getArticleData(_x8) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getArticleData = getArticleData;
